import { Preferences } from '@capacitor/preferences';

// plugin's methods
const methods = [
	'configure',
	'get',
	'set',
	'remove',
	'clear',
	'keys',
	'migrate',
	'removeOld',
];

export function useNativePreferences () {
	// methods
	const api = methods.reduce((api, name) => {
		api[name] = Preferences[name];
		return api;
	}, {});

	return {
		...api,
	};
}
